import { orgUserSchema } from './orgUser';
import { permissionSchema } from './permission';
export const roleSchema = {
    $id: 'urn:wisepipe-domain-authorize:Role',
    type: 'object',
    properties: {
        users: { type: 'array', items: { $ref: orgUserSchema.$id }, uniqueItemProperties: ['id'] },
        permissions: { type: 'array', items: { $ref: permissionSchema.$id } }
    },
    required: ['users', 'permissions']
};
//# sourceMappingURL=role.js.map